



























































import { ValidationObserver } from 'vee-validate';
import { Component, Emit, Mixins, VModel } from 'vue-property-decorator';

import ModelSetter from "../../Mixins/ModelSetter";
import { resetPassword } from "../../logic/auth/logic";
import TextInput from '../Pi/fields/TextInput/TextInput.vue';

enum ResetPasswordStepsEnum {
  Email,
  Hash,
}

@Component({
  data() {
    return {
      ResetPasswordStepsEnum
    }
  },
  components: {
    TextInput,
    ValidationObserver
  }
})
export default class ResetPasswordModal extends Mixins(ModelSetter) {
  @VModel({ type: Boolean }) isModalOpen!: boolean

  @Emit()
  passwordSet() {
    return null
  }

  model = {
    email: ''
  }

  currentStep: ResetPasswordStepsEnum = ResetPasswordStepsEnum.Email

  get okButtonTitle() {
    if (this.currentStep === ResetPasswordStepsEnum.Email) {
      return this.$t('next_title').toString()
    } else {
      return this.$t('accept').toString()
    }

  }

  submitStep() {
    if (this.currentStep === ResetPasswordStepsEnum.Email) {
      resetPassword(this.model.email)
        .then(res => {
          if (res) {
            this.currentStep = ResetPasswordStepsEnum.Hash
          }
        })
    } else {
      this.isModalOpen = false
    }

  }
}
